import { observer } from 'mobx-react-lite'
import Box from '@mui/material/Box'
import Typography from "@mui/material/Typography"
import { themeConfig } from '@gap/shared/theme'
import { DownloadOutlined, PictureAsPdfOutlined } from '@mui/icons-material'
import IconButton from "@mui/material/IconButton"
import { useAdvisorIntegrationFYIStore } from 'features/org/edit/integrations/FYI/AdvisorIntegrationFYIStore'
import useStore from 'reusable/mobx-store-utils'
import { useGapDialogStore } from 'reusable/gap-dialog/GapDialogStore'
import ShareDocumentDialogExportStore, { ShareDocumentDialogExportStoreProvider } from './ShareDocumentDialogExportStore'
import { useShareDocumentDialogStore } from '../ShareDocumentDialogStore'
import { usePrintStore } from 'reusable/printing/PrintStore'
import CircularProgress from '@mui/material/CircularProgress'
import ShareDocumentDialogExportCard from './ShareDocumentDialogExportCard'

export default observer(function ShareDocumentDialogExport() {
   const gapDialogStore = useGapDialogStore()
   const advisorIntegrationFYIStore = useAdvisorIntegrationFYIStore()
   const shareDocumentDialogStore = useShareDocumentDialogStore()
   const printStore = usePrintStore()

   const shareDocumentDialogExportStore = useStore(sp => new ShareDocumentDialogExportStore(sp), {
      gapDialogStore,
      advisorIntegrationFYIStore,
      shareDocumentDialogStore
   })

   return <ShareDocumentDialogExportStoreProvider store={shareDocumentDialogExportStore}>
      <>
         <Box sx={{ mb: 1 }}>
            <Typography variant="overline">APPS</Typography>
         </Box>

         {/* FYI CARD */}
         <ShareDocumentDialogExportCard
            title="FYI Docs"
            disabled={printStore.isGenerating}
            disabledText='Just a moment, a PDF is being generated and will be available to download shortly.'
            subTitle="Store client files directly in FYI Docs"
            mainIcon="/images/icons/fyi-docs-logo.svg"
            loading={advisorIntegrationFYIStore.loader.isLoading}
            rightComponent={shareDocumentDialogExportStore.FYICardRightComponent.component}
            onCardClick={shareDocumentDialogExportStore.FYICardRightComponent.handler}
         />
      </>

      <Box sx={{ mb: 1, mt: 3 }}>
         <Typography variant="overline">DOWNLOAD</Typography>
      </Box>

      {/* Download pdf card */}
      <ShareDocumentDialogExportCard
         title="Download as PDF"
         disabled={printStore.isGenerating}
         disabledText='Just a moment, a PDF is being generated and will be available to download shortly.'
         mainIcon={PictureAsPdfOutlined}
         rightComponent={<IconButton>
            {!shareDocumentDialogExportStore.downloadDocumentLoader.isLoading && <DownloadOutlined sx={{ color: themeConfig.primary['800'] }} />}
            {shareDocumentDialogExportStore.downloadDocumentLoader.isLoading && <CircularProgress size={28} />}
         </IconButton>}
         onCardClick={shareDocumentDialogExportStore.downloadDocument}
      />
   </ShareDocumentDialogExportStoreProvider>
})
